/**
 * auth.js
 */
export const SET_USER = 'SET_USER'
export const LOGOUT = 'LOGOUT'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_ENVIAR_CERTIFICADOS = 'SET_ENVIAR_CERTIFICADOS'
export const SET_ESTADO_LOTE = 'SET_ESTADO_LOTE'
export const SET_TIPO_RVOE_LOTE = 'SET_TIPO_RVOE_LOTE'
